// 登录等接口已对接后端，关闭 Mock
export const USE_MOCK = false;

// 开启前端登录校验（路由守卫与 401 跳转）
export const SKIP_AUTH = false;

function resolveWsUrl() {
    if (typeof window === 'undefined') {
        return 'ws://127.0.0.1:8585';
    }
    const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
    if (process.env.NODE_ENV === 'development') {
        return `${protocol}//${window.location.hostname}:8585`;
    }
    // 线上走 443 + /ws，由 Nginx 反代到 8585
    return `${protocol}//${window.location.host}/ws`;
}

// WebSocket 网关地址，可按环境覆盖
export const WS_URL = resolveWsUrl();
